import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { motion } from "framer-motion";
import BackgroundVideo from "../components/Background-Video";
import BackButton from "../partials/Back-Button";
import Videos from "../video/101160_SCS_Interactive_Sc8_4K_10s_V2.mp4";

const PrivateMobilityAirport = () => {
  const [activeDot, setActiveDot] = useState("");
  const [dotOneX, setDotOneX] = useState();
  const [dotOneY, setDotOneY] = useState();
  const [blobOneX, setBlobOneX] = useState();
  const [blobOneY, setBlobOneY] = useState();
  const [dotTwoX, setDotTwoX] = useState();
  const [dotTwoY, setDotTwoY] = useState();
  const [blobTwoX, setBlobTwoX] = useState();
  const [blobTwoY, setBlobTwoY] = useState();
  const [dotThreeX, setDotThreeX] = useState();
  const [dotThreeY, setDotThreeY] = useState();
  const [blobThreeX, setBlobThreeX] = useState();
  const [blobThreeY, setBlobThreeY] = useState();

  const getPosition = () => {
    const dotOne = document.getElementById("dotOne").getBoundingClientRect();
    const dotOneTop = dotOne.top;
    const dotOneLeft = dotOne.left;

    setDotOneX(dotOneLeft + 21.5);
    setDotOneY(dotOneTop + 21.5);

    const blobOne = document.getElementById("blobOne").getBoundingClientRect();
    const blobOneTop = blobOne.top;
    const blobOneLeft = blobOne.left;

    setBlobOneX(blobOneLeft);
    setBlobOneY(blobOneTop);

    const dotTwo = document.getElementById("dotTwo").getBoundingClientRect();
    const dotTwoTop = dotTwo.top;
    const dotTwoLeft = dotTwo.left;

    setDotTwoX(dotTwoLeft + 21.5);
    setDotTwoY(dotTwoTop + 21.5);

    const blobTwo = document.getElementById("blobTwo").getBoundingClientRect();
    const blobTwoTop = blobTwo.top;
    const blobTwoLeft = blobTwo.left;

    setBlobTwoX(blobTwoLeft);
    setBlobTwoY(blobTwoTop);

    const dotThree = document
      .getElementById("dotThree")
      .getBoundingClientRect();
    const dotThreeTop = dotThree.top;
    const dotThreeLeft = dotThree.left;

    setDotThreeX(dotThreeLeft + 21.5);
    setDotThreeY(dotThreeTop + 21.5);

    const blobThree = document
      .getElementById("blobThree")
      .getBoundingClientRect();
    const blobThreeTop = blobThree.top;
    const blobThreeLeft = blobThree.left;

    setBlobThreeX(blobThreeLeft);
    setBlobThreeY(blobThreeTop);
  };

  useEffect(() => {
    getPosition();
  }, []);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
      className="w-screen h-[calc(100vh-120px)] 2xl:h-[calc(100vh-172px)] relative top-[120px] 2xl:top-[172px] left-0"
    >
      <BackButton backurl="/private-wireless" />
      <BackgroundVideo fullscreen video={Videos} />
      <div className="w-screen h-[calc(100vh-120px)] 2xl:h-[calc(100vh-172px)] relative">
        <div className=" bg-opacity-50 backdrop-blur-md bg-white w-[557px] 2xl:w-[810px] py-7 px-9 2xl:py-14 2xl:pl-[59px] 2xl:pr-[40px] rounded-3xl relative left-10 top-0 zoom-8">
          <h1 className="font-semibold uppercase text-dell-blue font-proxima-nova text-lg 2xl:text-[25px] 2xl:leading-[30px] pb-3">
            Airports
          </h1>
          <p className=" text-[#444444] text-xl 2xl:text-[30px] 2xl:leading-[37px] font-proxima-nova font-thin">
            Grow your managed services business and monetize your 5G investment
            in modernizing airport operations.  
          </p>
        </div>

        <svg
          className={classnames(
            "fixed top-0 transition-all duration-300 ",
            activeDot === 1 ? "opacity-100 delay-75" : "opacity-0"
          )}
          width="100vw"
          height="100vh"
        >
          <line
            x1={dotOneX}
            y1={dotOneY}
            x2={blobOneX}
            y2={blobOneY}
            stroke="#444444"
            strokeDasharray="15 15"
          />
        </svg>

        <svg
          className={classnames(
            "fixed top-0 transition-all duration-300 ",
            activeDot === 2 ? "opacity-100 delay-75" : "opacity-0"
          )}
          width="100vw"
          height="100vh"
        >
          <line
            x1={dotTwoX}
            y1={dotTwoY}
            x2={blobTwoX}
            y2={blobTwoY}
            stroke="#444444"
            strokeDasharray="15 15"
          />
        </svg>

        <svg
          className={classnames(
            "fixed top-0 transition-all duration-300 ",
            activeDot === 3 ? "opacity-100 delay-75" : "opacity-0"
          )}
          width="100vw"
          height="100vh"
        >
          <line
            x1={dotThreeX}
            y1={dotThreeY}
            x2={blobThreeX}
            y2={blobThreeY}
            stroke="#444444"
            strokeDasharray="15 15"
          />
        </svg>

        <div className="edge-dots absolute w-screen h-[calc(100vh-172px)] top-0 grid grid-cols-5 grid-rows-3">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>

          <div className="relative flex align-middle justify-center">
            <div
              id="dotOne"
              className="dot z-10 absolute left-[30%] rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#444444] border-2 cursor-pointer"
              onMouseEnter={() => setActiveDot(1)}
              onMouseLeave={() => setActiveDot("")}
              onKeyUp={() => setActiveDot(1)}
              onKeyDown={() => setActiveDot("")}
              tabindex="0"
            ></div>
          </div>
          <div className="relative">
            <div
              id="dotTwo"
              className="dot z-10 absolute left-10 top-[21%] 2xl:top-[10%] rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#444444] border-2 cursor-pointer"
              onMouseEnter={() => setActiveDot(2)}
              onMouseLeave={() => setActiveDot("")}
              onKeyUp={() => setActiveDot(2)}
              onKeyDown={() => setActiveDot("")}
              tabindex="0"
            ></div>

            <div
              id="blobOne"
              className={classnames(
                "absolute bottom-0 px-10 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[384px] h-[384px] transition-all duration-300 ",
                activeDot === 1
                  ? "opacity-100 scale-75 2xl:scale-100 z-50"
                  : "opacity-0 scale-0"
              )}
            >
              <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                Baggage Management:
              </p>
              <p className="text-xl font-proxima-nova font-thin leading-6">
                Connected smart cameras can <br />
                monitor luggage and <br />
                streamline the management <br />
                and movement of passenger <br />
                luggage which can lead to
                <br />
                better on-time performance.
              </p>
            </div>
          </div>
          <div className="relative flex justify-center pt-9">
            <div
              id="blobTwo"
              className={classnames(
                "absolute bottom-10 right-[0%] px-10 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[394px] h-[394px] transition-all duration-300",
                activeDot === 2
                  ? "opacity-100 scale-75 2xl:scale-100 z-50"
                  : "opacity-0 scale-0"
              )}
            >
              <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                Critical Communication:{" "}
              </p>
              <p className="text-xl font-extralight leading-6">
                A private network can enable <br />
                voice, video and data <br />
                communication seamlessly <br />
                among airport operational <br />
                personnel who require constant <br />
                information exchanges.
              </p>
            </div>
          </div>
          <div className="relative flex justify-start">
            <div
              id="blobThree"
              className={classnames(
                "absolute left-24 bottom-12 2xl:left-64 2xl:bottom-36 px-10 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[364px] h-[364px] transition-all duration-300",
                activeDot === 3
                  ? "opacity-100 scale-75 2xl:scale-100 z-50"
                  : "opacity-0 scale-0"
              )}
            >
              <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                Cargo Optimization:
              </p>
              <p className="text-xl font-proxima-nova font-thin leading-6">
                AR-assisted glasses show <br />
                details like weight, loading <br />
                sequence and the allocated <br />
                position of bags and cargo in the <br />
                aircraft which help to reduce fuel <br />
                burn and costs.
              </p>
            </div>
            <div
              id="dotThree"
              className="dot z-10 absolute rounded-full left-10 top-[41%] 2xl:top-[20%] w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#444444] border-2 cursor-pointer"
              onMouseEnter={() => setActiveDot(3)}
              onMouseLeave={() => setActiveDot("")}
              onKeyUp={() => setActiveDot(3)}
              onKeyDown={() => setActiveDot("")}
              tabindex="0"
            ></div>
          </div>
          <div></div>

          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </motion.div>
  );
};

export default PrivateMobilityAirport;
